import React from 'react';
import { updateCmsContentVariables, createCmsContentVariables } from '@api/graphql/types';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import Form, { FormFooterPosition } from '@components/Form/Form';

type formDataType = updateCmsContentVariables | createCmsContentVariables;

type Props = {
    formData: formDataType,
    onSubmit: (formData: formDataType) => Promise<any>,
    redirectFunction?: (submitResponse: any) => string | undefined,
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: formDataType;
}

class CmsForm extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            formData: this.props.formData,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({formData: props.formData});
    }

    private validate = (formData: formDataType) => {
        return true;
    }

    public render() {
        const fields = [
            {name: 'title', type: 'text', props: {required: true}},
            {name: 'url_key', type: 'text', props: {required: true}},
            {name: 'content', type: 'markdown', props: {prefix: 'cms'}},
            {name: 'is_active', type: 'checkbox', props: {required: true}},
            {name: 'active_from', type: 'datetime'},
            {name: 'active_to', type: 'datetime'},
            {name: 'meta_title', type: 'text'},
            {name: 'meta_keywords', type: 'text'},
            {name: 'meta_description', type: 'text'},
        ];

        return (
            <Form
                fields={[{id: 'default', fields}]}
                intlPrefix={'module.cms'}
                onSubmit={this.props.onSubmit}
                formData={this.props.formData}
                redirectPath={this.props.redirectFunction ? this.props.redirectFunction : Path.cms}
                validate={this.validate}
                footerPosition={FormFooterPosition.BOTH}
            />
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(CmsForm);



// WEBPACK FOOTER //
// ./src/modules/Cms/components/CmsForm.tsx